import * as React from 'react';
import './Action.css';

interface ActionProps {
  nowChecking: boolean;
  nowHashing: boolean;
  nowUploading: boolean;
  hashable: boolean;
  executeHash: () => void;
  uploadable: boolean;
  executeUpload: () => void;
}

interface ActionState {
  scrollTop: number;
}

export class Action extends React.Component<ActionProps, ActionState> {
  constructor(props: ActionProps) {
    super(props);
    this.state = { scrollTop: 0 };
  }

  public render() {
    return (
      <div className={'Action'} style={this.style}>
        <h2><span>操作</span></h2>
        {this.notReady && <div>ファイルを選択してください</div>}
        {this.props.nowChecking && <div>ファイルのチェック中です</div>}
        {this.props.nowHashing && <div>匿名化処理中です</div>}
        {this.props.nowUploading && <div>アップロード中です</div>}
        {this.props.hashable && this.hashButton}
        {this.uploadable && this.uploadButton}
      </div>
    );
  }

  public componentDidMount() {
    window.addEventListener('scroll', () => this.updateScrollTop());
  };

  private updateScrollTop() {
    const scrollTop = Math.max(
      document.body.scrollTop,
      window.pageYOffset,
      document.documentElement.scrollTop
    );
    this.setState({ scrollTop });
  }

  private get hashButton() {
    return <button id="hash" onClick={this.props.executeHash}>匿名化</button>;
  }

  private get uploadButton() {
    return <button id="upload" onClick={this.props.executeUpload}>アップロード</button>;
  }

  private get uploadable() {
    return this.props.uploadable && !this.props.nowUploading;
  }

  private get notReady() {
    return !this.props.hashable &&
           !this.props.uploadable &&
           !this.props.nowChecking &&
           !this.props.nowHashing;
  }

  private get style() {
    return {
      transform: `translateY(${this.state.scrollTop}px)`
    };
  }
}